<template>
  <el-dialog :title="title" :visible="visible" width="40%" :before-close="handleClose">
    <el-image :src="shareImg" class="share-img"></el-image>
    <div slot="footer">
      <!-- <el-button @click="$emit('update:visible', false)">再想想</el-button> -->
      <el-button type="primary" @click="$emit('update:visible', false)">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    shareImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
    async confirm() {
      // this.$refs["form"].validate(async (valid) => {
      //   if (valid) {
      //     await this.$api.updateRewardScore({ ...this.form });
      //     this.$message.success("操作成功");
      //     this.$emit("dialogCallback");
      //     this.$emit("update:visible", false);
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.share-img {
  width: 430px;
  margin: 0 auto;
  display: block;
}
</style>
